import React from 'react'
import { Link } from 'react-router-dom'
import SectionTitle from '../SectionTitle'
import { useTranslation } from 'react-i18next'




const ServiceSection = ({ services, ServicesIsLoading, ServicesIsError }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();

    return (
        <div className={`wpo-service-area section-padding `}>
            <div className="container">
                <SectionTitle
                    subTitle={t('sectionTitle.services.capabilities')}
                    MainTitle={t('sectionTitle.services.whatWeDo')}
                />
                <div className="row align-items-center">
                {ServicesIsLoading ? <p>{t("loading")}...</p> : ServicesIsError ? <p>{t("error")}</p> : services?.map((service, sitem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={sitem}>
                            <div className="wpo-service-item">
                                <img style={{ width: "40px", height: "40px" }} src={`${process.env.REACT_APP_API_URL}/api/images/${service?.data?.icon}`} alt={service?.data?.title}></img>
                                <h2>{service?.data?.title}</h2>
                                <p>{service?.data?.description.slice(0, 100)}...</p>
                                <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{t('learnMore')}...</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ServiceSection;